/**
 * window.apiRequestOk(endpoint, init): window.ApiClient.request that rejects
 * when the client is missing or the response is not ok. The error carries the
 * HTTP `status`, 0 when there was no response.
 */
(function () {
  'use strict';

  window.apiRequestOk = function (endpoint, init) {
    if (!window.ApiClient || typeof window.ApiClient.request !== 'function') {
      return Promise.reject(new Error('ApiClient unavailable'));
    }
    return window.ApiClient.request(endpoint, init).then(function (resp) {
      if (!resp || !resp.ok) {
        var err = new Error('Request failed: ' + (resp ? resp.status : 'no response'));
        err.status = resp ? resp.status : 0;
        throw err;
      }
      return resp;
    });
  };
})();
